import { Alert } from '@gitbook/spine-react';

import type { UpgradeAction } from '../../state';

/**
 * An alert to display when the user needs to upgrade to use merge rules.
 */
export function MergeRulesUpgradeAlert(props: { upgrade: UpgradeAction }): React.ReactElement {
    const { upgrade } = props;

    return (
        <Alert
            size="xsmall"
            kind="upgrade"
            details="Upgrade your organization and configure your GitBook workflow to match your team's needs."
            action={{
                leadingIcon: upgrade.leadingIcon,
                label: upgrade.label,
                onPress: upgrade.onPress,
            }}
        />
    );
}
